import { Typography } from '@mui/material';
import {
  ChipContainer,
  GameDetailsContainer,
  ProvidersContainer,
  TeamRow,
} from '../GameFinder.styled';
import { formatTime } from '../../../services/util/date/formatTime';
import { getProviderData } from '../../../services/util/streamingpackage/getProviderImageAndUrl';
import CustomTooltip from '../../shared/tooltip/CustomTooltip';
import { Game } from '../../../interfaces/Games.interface';
import React from 'react';

type GameFinderResultProps = {
  game: Game;
  liveProviders: string[];
  highlightProviders: string[];
};
const GameFinderResult: React.FC<GameFinderResultProps> = ({
  game,
  liveProviders,
  highlightProviders,
}) => {
  return (
    <GameDetailsContainer key={game.id}>
      <TeamRow>
        <ChipContainer>
          <Typography variant="h5" color="primary">
            {game.team_home}
          </Typography>{' '}
          -
          <Typography variant="h5" color="primary">
            {game.team_away}
          </Typography>
        </ChipContainer>
      </TeamRow>
      <Typography variant="body2" color="textDisabled">
        {formatTime(game.starts_at)}
      </Typography>

      <ProvidersContainer>
        <Typography variant="body2">Live Streaming:</Typography>
        {liveProviders.length > 0 ? (
          liveProviders.map((provider: string) => {
            const providerData = getProviderData(provider);
            return providerData ? (
              <CustomTooltip
                key={provider}
                icon={
                  <img
                    src={providerData.image}
                    width="40px"
                    style={{
                      borderRadius: '8px',
                      marginRight: '10px',
                    }}
                    alt={provider}
                  />
                }
                title={provider}
              />
            ) : null;
          })
        ) : (
          <Typography variant="body2">None</Typography>
        )}
      </ProvidersContainer>

      <ProvidersContainer>
        <Typography variant="body2">Highlights:</Typography>
        {highlightProviders.length > 0 ? (
          highlightProviders.map((provider: string) => {
            const providerData = getProviderData(provider);
            return providerData ? (
              <CustomTooltip
                key={provider}
                icon={
                  <img
                    src={providerData.image}
                    width="40px"
                    style={{
                      borderRadius: '8px',
                      marginRight: '10px',
                    }}
                    alt={provider}
                  />
                }
                title={provider}
              />
            ) : null;
          })
        ) : (
          <Typography variant="body2">None</Typography>
        )}
      </ProvidersContainer>
    </GameDetailsContainer>
  );
};
export default GameFinderResult;
